"use strict";

exports.__esModule = true;
exports.updateValueByIdentifier = void 0;

var _TagSchemas = require("../../types/TagSchemas");

var _isEmpty = require("../../utils/is-empty");

var _buildTagByValue = require("../utils/build-tag-by-value");

var _updateBySchema = require("./update-by-schema");

var updateValueByIdentifier = function updateValueByIdentifier(tags, identifier, value, meta, enableValidation) {
  if (tags === void 0) {
    tags = [];
  }

  if (enableValidation === void 0) {
    enableValidation = true;
  }

  var tag = (0, _buildTagByValue.buildTagByValueAndIdentifier)(value, identifier, enableValidation);

  if ((0, _isEmpty.isEmpty)(tag)) {
    return tags;
  }

  if (meta) {
    tag.meta = meta;
  }

  var tagSchema = _TagSchemas.TAG_SCHEMAS[identifier];
  return (0, _updateBySchema.updateValueBySchema)(tags, tagSchema, value, meta, enableValidation);
};

exports.updateValueByIdentifier = updateValueByIdentifier;